/**
 * TanStack Query Client Configuration
 *
 * Centralized query client with optimized defaults for:
 * - Cache management (staleTime, gcTime)
 * - Retry logic
 * - Error handling
 * - Refetch strategies
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 5 minutes
      staleTime: 5 * 60 * 1000, // 5 minutes

      // Garbage collection time (how long unused data stays in cache)
      gcTime: 10 * 60 * 1000, // 10 minutes (previously cacheTime)

      // Retry failed requests 3 times with exponential backoff
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),

      // Don't refetch on window focus to avoid unnecessary requests
      refetchOnWindowFocus: false,

      // Refetch on mount only if data is stale
      refetchOnMount: true,

      // Don't refetch on reconnect by default
      refetchOnReconnect: false,
    },
    mutations: {
      // Retry mutations only once
      retry: 1,
      retryDelay: 1000,
    },
  },
});
